import { BrowserRouter, Navigate, Route, Routes, useLocation  } from "react-router-dom";
import React, { useState,useEffect  } from 'react';
import './App.css';
import MainContainer from "./components/MainContainer";
import Header from "./components/Header";
import Footer from "./components/Footer";
import './css/bootstrap.min.css';
//import './css/icons.min.css';
// import './css/app.min.css';
import './css/style.css';


function App() {
  const [pageTitle, setPageTitle] = useState('');

  const handleNavigation = (newPageTitle) => {
    setPageTitle(newPageTitle);
    // Perform the navigation here
  };

  return (
    <div className="app">
        <Header></Header>
        <div className="main-wrapper">
          <MainContainer></MainContainer>
          <Footer></Footer>
        </div>
    </div>
  );
}

export default App;
